// removed by extract-text-webpack-plugin
module.exports = {"containerFix":"styles__containerFix__oRtjr","cardContainer":"styles__cardContainer__1II_d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StartupCards/styles.scss
// module id = 412
// module chunks = 0